import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { mobileapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'fetch_data_success',
    payload: data,
});

//To get list of officers data
export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid };
            const apiname = mobileapi.mobidashboard;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

 